import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { FruitifyUserSearch } from "../components/FruitifyUserSearch";

function ImpersonationView() {
  return (
    <FruitifyContainer>
      <FruitifyUserSearch title={"Users"} />{" "}
    </FruitifyContainer>
  );
}

export default ImpersonationView;
